import { render, staticRenderFns } from "./InputTwoFactorAuthCode.vue?vue&type=template&id=6bf415dd&scoped=true&"
import script from "./InputTwoFactorAuthCode.vue?vue&type=script&lang=js&"
export * from "./InputTwoFactorAuthCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf415dd",
  null
  
)

export default component.exports